// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comments-page-container {
  --body-bg: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  --msger-bg: #fff;
  --border: 2px solid #ddd;
  --left-msg-bg: #ececec;
  --right-msg-bg: #579ffb;
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  width: 100%;
  height: 98%;
  border-radius: 5px;
  background: var(--msger-bg);
}
.comments-page-container .no-comments-found {
  height: calc(100vh - 18rem);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
}
.comments-page-container .msger-inputarea {
  padding: 10px;
  border-top: 0px;
  background: transparent;
  width: 100%;
}
.comments-page-container .msger-inputarea .comments-view-buttons {
  display: flex;
  width: 100%;
  align-items: center;
  margin: 0.6rem 0;
}
.comments-page-container .msger-inputarea .comments-view-buttons .submissions {
  gap: 10px;
  display: flex;
}
.comments-page-container .msger-inputarea .comments-view-buttons .submissions .comments-button {
  height: 35px;
  width: 35px;
  padding: 0px;
  border-radius: 50%;
}
.comments-page-container #chat-container {
  flex: 1;
  padding: 10px;
  min-height: 12rem;
  height: calc(100vh - 18rem);
  overflow: auto;
  width: 100%;
}
.comments-page-container #emoji-list {
  z-index: 50;
  margin-bottom: -400px;
  right: 15%;
  position: absolute;
  bottom: 27rem;
  right: 8rem;
}
.comments-page-container .commentsSaveButton {
  margin-left: 10px;
  background: rgb(0, 196, 65);
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.23s;
}
.comments-page-container .updates {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-self: center;
  width: 100%;
  margin-bottom: 1rem;
}
.comments-page-container .updates .update {
  background: rgba(108, 117, 125, 0.062745098);
  margin-bottom: 0.5rem;
  padding: 0.75rem;
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  word-break: break-word;
}
.comments-page-container .updates .update:hover {
  background: rgba(108, 117, 125, 0.1254901961);
}
.comments-page-container .updates .update .k-button k-primary {
  width: 60px;
  height: 40px;
  margin-left: 30px;
}
.comments-page-container .updates .update h5,
.comments-page-container .updates .update h4 {
  margin: 0;
}
.comments-page-container .updates .update h5 {
  color: #6c757d;
  font-weight: 600;
}
.comments-page-container .updates .update h4 {
  color: #6c757d;
  font-weight: 600;
}
.comments-page-container .updates .button {
  background: rgba(76, 117, 242, 0.062745098);
  height: 3rem;
  display: flex;
  flex-direction: row;
  color: #4c75f2;
  width: 13rem;
}
.comments-page-container .updates .button > * {
  align-self: center;
}
.comments-page-container .updates .button:hover {
  background: rgba(76, 117, 242, 0.1882352941);
}
.comments-page-container .updates a {
  color: inherit;
  text-decoration: none;
  flex-direction: row;
  display: flex;
}
.comments-page-container .updates a > * {
  align-self: center;
}
.comments-page-container .commentBox {
  flex: 1;
  background: #ddd;
  margin-top: 5px;
}
.comments-page-container .msger-inputarea * {
  border: none;
  border-radius: 3px;
  font-size: 1em;
  background: transparent;
}
.comments-page-container .mentions__control {
  height: 5rem !important;
  background: rgba(136, 136, 136, 0.0901960784) !important;
}
.comments-page-container .sendButton {
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.23s;
}
.comments-page-container .msg {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}
.comments-page-container .msg-bubble {
  max-width: 100%;
  padding: 5px;
  word-break: break-word;
  background: transparent;
  width: 95%;
  border-radius: 5px;
  display: flex;
}
.comments-page-container .msg-text {
  white-space: pre-wrap;
  display: grid;
  margin-top: 10px;
  font-size: 14px;
  margin-bottom: 10px;
}
.comments-page-container .msg-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  white-space: nowrap;
  width: 100%;
}
.comments-page-container .msg-info-time {
  font-size: 11px;
}
.comments-page-container .msg-info-time div {
  color: #3636ff;
}
.comments-page-container .msg-info-time div:hover {
  text-decoration: underline;
  cursor: pointer;
}
.comments-page-container .reply-comment {
  min-width: 13rem;
}
.comments-page-container .reply-comment .msger-inputarea {
  margin: 10px 0px 0px 0px !important;
}
.comments-page-container .reply-comment .msger-inputarea h4, .comments-page-container .reply-comment .msger-inputarea .comments-view-buttons {
  font-size: 12px !important;
}
.comments-page-container .msg-info-name {
  font-weight: 500;
  font-size: 1rem;
  color: #000;
}
.comments-page-container .right-msg .msg-img {
  float: left;
}
.comments-page-container .msg-img {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  background: #ddd;
  background-repeat: no-repeat !important;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
  float: left;
  padding: 15px;
}
.comments-page-container thead {
  display: none;
}
.comments-page-container .k-grid-table {
  border-spacing: 1em;
}
.comments-page-container .k-grid-table td:first-child {
  background-color: #ededed;
  border-radius: 15px;
}
.comments-page-container .k-grid-table .k-grid td {
  border-width: 0px;
}
.comments-page-container .k-grid-header .k-grid .k-alt,
.comments-page-container .k-grid-table .k-grid .k-alt {
  background-color: transparent !important;
}
.comments-page-container .k-grid-header th,
.comments-page-container .k-grid-table th {
  background-color: #f6f8fa;
  color: #8f9bb3;
}
.comments-page-container .k-grid-header td,
.comments-page-container .k-grid-table td {
  border-bottom: 1px solid #ebeff2;
}
.comments-page-container .k-grid-header .k-grid th,
.comments-page-container .k-grid-header .k-grid td,
.comments-page-container .k-grid-table .k-grid th,
.comments-page-container .k-grid-table .k-grid td {
  padding: 10px !important;
}
.comments-page-container .mentions {
  width: 100%;
}
.comments-page-container .mentions textarea,
.comments-page-container .mentions .mentions__highlighter {
  letter-spacing: 2px;
  height: 100%;
}
.comments-page-container .mentions__suggestions {
  z-index: 1000;
  top: 5rem !important;
  width: 83% !important;
  margin-left: 10rem;
}
.comments-page-container .mentions__suggestions__list {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-size: 10pt;
}
.comments-page-container .mentions__suggestions__item {
  padding: 5px 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}
.comments-page-container .comment-date {
  padding-bottom: 5px;
  font-size: 13px;
}
.comments-page-container html,
.comments-page-container body {
  height: 100%;
}
.comments-page-container html {
  font-family: Roboto, sans-serif;
  background: linear-gradient(to right, #57c1eb 0%, #246fa8 100%);
  font-size: 10px;
}
.comments-page-container body {
  display: grid;
  place-items: center;
}
.comments-page-container #container {
  min-width: 800px;
  max-width: 1000px;
  max-height: 500px;
  height: 95vh;
  background: #fff;
  border-radius: 15px;
}
.comments-page-container #chat-message-list .panel {
  border-color: #ddd;
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
.comments-page-container #chat-message-list .panel.arrow.left:before {
  left: 0px;
  top: 30px;
  border-right-color: inherit;
  border-width: 16px;
}
.comments-page-container #chat-message-list .panel-body {
  padding: 15px;
}
.comments-page-container #chat-message-list .btn-sm {
  padding: 5px 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
}
.comments-page-container #chat-message-list figure.thumbnail {
  display: block;
  padding: 4px;
  margin-bottom: 20px;
  line-height: 1.42857143;
  background-color: #fff;
  border: 1px solid #ddd;
  text-align: center;
  border-radius: 4px;
  -webkit-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}
.comments-page-container #chat-message-list .thumbnail img {
  max-width: 100%;
  max-height: 60px;
}
.comments-page-container #chat-message-list .panel:before {
  left: 0px;
  top: 30px;
  border-right-color: inherit;
  border-width: 16px;
}
.comments-page-container #chat-message-list .btn-default {
  color: #333;
  background-color: #fff;
  border-color: #ccc;
}
.comments-page-container .comment-replies {
  border-left: 1.5px solid rgba(136, 136, 136, 0.3333333333);
  padding-left: 5px;
  margin-top: 0.7rem;
}
.comments-page-container .comment-replies .reply-toggle .display-flex {
  align-items: center;
  color: #526aec;
  font-size: 12px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/App/Styles/commentsView.scss"],"names":[],"mappings":"AAAA;EAOI,4DAAA;EACA,gBAAA;EACA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,WAAA;EAEA,kBAAA;EACA,2BAAA;AANJ;AAQI;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AANN;AAQI;EAEE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;AAPN;AASM;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAPR;AAQQ;EACE,SAAA;EACA,aAAA;AANV;AAQU;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AANZ;AAYI;EACE,OAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;AAVN;AAaI;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AAXN;AAcI;EACE,iBAAA;EACA,2BAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,4BAAA;AAZN;AAeI;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAbN;AAeM;EACE,4CAzFS;EA0FT,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAdR;AAgBQ;EACE,6CArGO;AAuFjB;AAiBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAfV;AAkBQ;;EAEE,SAAA;AAhBV;AAmBQ;EACE,cAnHC;EAoHD,gBAAA;AAjBV;AAoBQ;EACE,cAxHC;EAyHD,gBAAA;AAlBV;AAsBM;EACE,2CA7HU;EA8HV,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAhII;EAiIJ,YAAA;AApBR;AAqBQ;EACE,kBAAA;AAnBV;AAsBQ;EACE,4CAtIQ;AAkHlB;AAwBM;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;AAtBR;AAuBQ;EACE,kBAAA;AArBV;AA0BI;EACE,OAAA;EACA,gBAAA;EACA,eAAA;AAxBN;AA0BI;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;AAxBN;AA2BI;EACE,uBAAA;EACA,wDAAA;AAzBN;AA2BI;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,4BAAA;AAzBN;AA2BI;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AAzBN;AA2BI;EACE,eAAA;EACA,YAAA;EAGA,sBAAA;EAEA,uBAAA;EAEA,UAAA;EACA,kBAAA;EAEA,aAAA;AA9BN;AAiCI;EACE,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA/BN;AAiCI;EAME,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AApCN;AA0DI;EACE,eAAA;AAxDN;AAyDM;EACE,cAAA;AAvDR;AAwDQ;EACE,0BAAA;EACA,eAAA;AAtDV;AA0DI;EACE,gBAAA;AAxDN;AAyDM;EACE,mCAAA;AAvDR;AAwDQ;EACE,0BAAA;AAtDV;AA0DI;EAEE,gBAAA;EAEA,eAAA;EACA,WAAA;AA1DN;AA+DI;EAEE,WAAA;AA9DN;AAgEI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,uCAAA;EACA,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AA9DN;AAgEI;EACE,aAAA;AA9DN;AAiEI;EACE,mBAAA;AA/DN;AAiEM;EACE,yBAAA;EACA,mBAAA;AA/DR;AAkEM;EACE,iBAAA;AAhER;AAqEM;;EACE,wCAAA;AAlER;AAqEM;;EACE,yBAAA;EACA,cAAA;AAlER;AAqEM;;EACE,gCAAA;AAlER;AAqEM;;;;EAEE,wBAAA;AAjER;AAqEI;EACE,WAAA;AAnEN;AAqEM;;EAEE,mBAAA;EACA,YAAA;AAnER;AA0EI;EACE,aAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;AAxEN;AA0EI;EACE,uBAAA;EACA,qCAAA;EACA,eAAA;AAxEN;AA2EI;EACE,iBAAA;EACA,4CAAA;AAzEN;AA4EI;EACE,mBAAA;EACA,eAAA;AA1EN;AA6EI;;EAEE,YAAA;AA3EN;AA8EI;EACE,+BAAA;EACA,+DAAA;EACA,eAAA;AA5EN;AA+EI;EACE,aAAA;EACA,mBAAA;AA7EN;AA+EI;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AA7EN;AAgFM;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iDAAA;EACA,yCAAA;AA9ER;AAgFM;EACE,SAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;AA9ER;AAgFM;EACE,aAAA;AA9ER;AAgFM;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA9ER;AAgFM;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,mCAAA;EACA,gCAAA;AA9ER;AAgFM;EACE,eAAA;EACA,gBAAA;AA9ER;AAgFM;EACE,SAAA;EACA,SAAA;EACA,2BAAA;EACA,kBAAA;AA9ER;AAgFM;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;AA9ER;AAiFI;EACE,0DAAA;EACA,iBAAA;EACA,kBAAA;AA/EN;AAkFQ;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAhFV","sourcesContent":[".comments-page-container {\n    $gray-light: #6c757d10;\n    $gray-hover: #6c757d20;\n    $gray: #6c757d;\n    $pblue-light: #4c75f210;\n    $pblue: #4c75f2;\n    $pblue-hover: #4c75f230;\n    --body-bg: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n    --msger-bg: #fff;\n    --border: 2px solid #ddd;\n    --left-msg-bg: #ececec;\n    --right-msg-bg: #579ffb;\n    display: flex;\n    flex-flow: column wrap;\n    justify-content: space-between;\n    width: 100%;\n    height: 98%;\n    // border: var(--border);\n    border-radius: 5px;\n    background: var(--msger-bg);\n    // box-shadow: 0 15px 15px -5px rgba(0, 0, 0, 0.2);\n    .no-comments-found{\n      height: calc(100vh - 18rem);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #888;\n    }\n    .msger-inputarea {\n      // display: flex;\n      padding: 10px;\n      border-top: 0px;\n      background: transparent;\n      width: 100%;\n      \n      .comments-view-buttons {\n        display: flex;\n        width: 100%;\n        align-items: center;\n        margin: 0.6rem 0;\n        .submissions {\n          gap: 10px;\n          display: flex;\n\n          .comments-button{\n            height: 35px;\n            width: 35px;\n            padding: 0px;\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n\n    #chat-container {\n      flex: 1;\n      padding: 10px;\n      min-height: 12rem;\n      height: calc(100vh - 18rem);\n      overflow: auto;\n      width: 100%;\n    }\n\n    #emoji-list {\n      z-index: 50;\n      margin-bottom: -400px;\n      right: 15%;\n      position: absolute;\n      bottom: 27rem;\n      right: 8rem;\n    }\n\n    .commentsSaveButton {\n      margin-left: 10px;\n      background: rgb(0, 196, 65);\n      color: #fff;\n      font-weight: bold;\n      cursor: pointer;\n      transition: background 0.23s;\n    }\n\n    .updates {\n      margin-top: 10px;\n      display: flex;\n      flex-direction: column;\n      align-self: center;\n      width: 100%;\n      margin-bottom: 1rem;\n\n      .update {\n        background: $gray-light;\n        margin-bottom: 0.5rem;\n        padding: 0.75rem;\n        border-radius: 5px;\n        transition: all 0.2s ease-in-out;\n\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        word-break: break-word;\n\n        &:hover {\n          background: $gray-hover;\n        }\n\n        .k-button k-primary {\n          width: 60px;\n          height: 40px;\n          margin-left: 30px;\n        }\n\n        h5,\n        h4 {\n          margin: 0;\n        }\n\n        h5 {\n          color: $gray;\n          font-weight: 600;\n        }\n\n        h4 {\n          color: $gray;\n          font-weight: 600;\n        }\n      }\n\n      .button {\n        background: $pblue-light;\n        height: 3rem;\n        display: flex;\n        flex-direction: row;\n        color: $pblue;\n        width: 13rem;\n        & > * {\n          align-self: center;\n        }\n\n        &:hover {\n          background: $pblue-hover;\n        }\n      }\n\n      a {\n        color: inherit;\n        text-decoration: none;\n        flex-direction: row;\n        display: flex;\n        & > * {\n          align-self: center;\n        }\n      }\n    }\n\n    .commentBox {\n      flex: 1;\n      background: #ddd;\n      margin-top: 5px;\n    }\n    .msger-inputarea * {\n      border: none;\n      border-radius: 3px;\n      font-size: 1em;\n      background: transparent;\n    }\n\n    .mentions__control {\n      height: 5rem !important;\n      background: #88888817 !important;\n    }\n    .sendButton {\n      color: #fff;\n      font-weight: bold;\n      cursor: pointer;\n      transition: background 0.23s;\n    }\n    .msg {\n      display: flex;\n      align-items: flex-end;\n      margin-bottom: 10px;\n    }\n    .msg-bubble {\n      max-width: 100%;\n      padding: 5px;\n      // border-radius: 15px;\n      // background: var(--left-msg-bg);\n      word-break: break-word;\n\n      background: transparent;\n      // color: #275362;\n      width: 95%;\n      border-radius: 5px;\n\n      display: flex;\n      // align-items: center;\n    }\n    .msg-text {\n      white-space: pre-wrap;\n      display: grid;\n      margin-top: 10px;\n      font-size: 14px;\n      margin-bottom: 10px;\n    }\n    .msg-info {\n      // display: inline-flex;\n      // justify-content: space-between;\n      // align-items: center;\n      // margin-bottom: 10px;\n\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n      white-space: nowrap;\n      width: 100%;\n    }\n\n    .msg-info-extra {\n    }\n\n    // .right-msg .msg-bubble {\n    //   background: transparent;\n    //   color: #275362;\n    //   width: 50%;\n    //   // border: 1px solid #275362;\n    //   border-radius: 5px;\n    // }\n    // .left-msg .msg-bubble {\n    //   background: transparent;\n    //   color: #275362;\n    //   width: 50%;\n    //   border-radius: 5px;\n    //   // display: table-column-group;\n    //   // border-bottom: 1px solid #275362;\n    //   // border-radius: 0px;\n    // }\n    .msg-info-time {\n      font-size: 11px;\n      div{\n        color : #3636ff;\n        &:hover{\n          text-decoration: underline;\n          cursor: pointer;\n        }\n      }\n    }\n    .reply-comment{\n      min-width: 13rem;\n      .msger-inputarea{\n        margin: 10px 0px 0px 0px !important;\n        h4,  .comments-view-buttons{\n          font-size: 12px !important;\n        }\n      }\n    }\n    .msg-info-name {\n      // margin-right: 10px;\n      font-weight: 500;\n      // margin-bottom: 10px;\n      font-size: 1rem;\n      color: #000;\n    }\n    .right-msg {\n      // flex-direction: row-reverse;\n    }\n    .right-msg .msg-img {\n      // margin: 5px;\n      float: left;\n    }\n    .msg-img {\n      width: 25px;\n      height: 25px;\n      margin-right: 10px;\n      background: #ddd;\n      background-repeat: no-repeat !important;\n      background-position: center;\n      background-size: cover;\n      border-radius: 50%;\n      float: left;\n      padding: 15px;\n    }\n    thead {\n      display: none;\n    }\n\n    .k-grid-table {\n      border-spacing: 1em;\n\n      td:first-child {\n        background-color: #ededed;\n        border-radius: 15px;\n      }\n\n      .k-grid td {\n        border-width: 0px;\n      }\n    }\n    .k-grid-header,\n    .k-grid-table {\n      .k-grid .k-alt {\n        background-color: transparent !important;\n      }\n\n      th {\n        background-color: #f6f8fa;\n        color: #8f9bb3;\n      }\n\n      td {\n        border-bottom: 1px solid #ebeff2;\n      }\n\n      .k-grid th,\n      .k-grid td {\n        padding: 10px !important;\n      }\n    }\n\n    .mentions {\n      width: 100%;\n\n      textarea,\n      .mentions__highlighter {\n        letter-spacing: 2px;\n        height: 100%;\n      }\n    }\n\n    // .mentions--multiLine {\n    //   overflow-y: scroll !important;\n    // }\n    .mentions__suggestions {\n      z-index: 1000;\n      top: 5rem !important;\n      width: 83% !important;\n      margin-left: 10rem;\n    }\n    .mentions__suggestions__list {\n      background-color: white;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n      font-size: 10pt;\n    }\n\n    .mentions__suggestions__item {\n      padding: 5px 15px;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    }\n\n    .comment-date {\n      padding-bottom: 5px;\n      font-size: 13px;\n    }\n\n    html,\n    body {\n      height: 100%;\n    }\n\n    html {\n      font-family: Roboto, sans-serif;\n      background: linear-gradient(to right, #57c1eb 0%, #246fa8 100%);\n      font-size: 10px;\n    }\n\n    body {\n      display: grid;\n      place-items: center;\n    }\n    #container {\n      min-width: 800px;\n      max-width: 1000px;\n      max-height: 500px;\n      height: 95vh;\n      background: #fff;\n      border-radius: 15px;\n    }\n    #chat-message-list {\n      .panel {\n        border-color: #ddd;\n        margin-bottom: 20px;\n        background-color: #fff;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n        -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n      }\n      .panel.arrow.left:before {\n        left: 0px;\n        top: 30px;\n        border-right-color: inherit;\n        border-width: 16px;\n      }\n      .panel-body {\n        padding: 15px;\n      }\n      .btn-sm {\n        padding: 5px 10px;\n        font-size: 12px;\n        line-height: 1.5;\n        border-radius: 3px;\n      }\n      figure.thumbnail {\n        display: block;\n        padding: 4px;\n        margin-bottom: 20px;\n        line-height: 1.42857143;\n        background-color: #fff;\n        border: 1px solid #ddd;\n        text-align: center;\n        border-radius: 4px;\n        -webkit-transition: all 0.2s ease-in-out;\n        -o-transition: all 0.2s ease-in-out;\n        transition: all 0.2s ease-in-out;\n      }\n      .thumbnail img {\n        max-width: 100%;\n        max-height: 60px;\n      }\n      .panel:before {\n        left: 0px;\n        top: 30px;\n        border-right-color: inherit;\n        border-width: 16px;\n      }\n      .btn-default {\n        color: #333;\n        background-color: #fff;\n        border-color: #ccc;\n      }\n    }\n    .comment-replies{\n      border-left: 1.5px solid #8885;\n      padding-left: 5px;\n      margin-top: .7rem;\n\n      .reply-toggle{\n        .display-flex {\n          align-items: center;\n          color : #526aec;\n          font-size: 12px;\n          cursor: pointer;\n        }\n      }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
